module.exports = __webpack_public_path__ + "public/images/architect.a47b2ebb30e08ad2a828d1d317b09a3c.webp";